import colors from '../colors.js';
var o = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
export { o as default };
//# sourceMappingURL=Pastel1.js.map
